// import { useDropzone } from "react-dropzone";

// const FileUpload = ({ handleFileUpload }: { handleFileUpload: (file: File) => void }) => {
//   const { getRootProps, getInputProps } = useDropzone({
//     accept: { "application/vnd.ms-excel": [".xls", ".xlsx"] },
//     onDrop: (acceptedFiles) => handleFileUpload(acceptedFiles[0]),
//   });

//   return (
//     <div {...getRootProps()} className="dropzone">
//       <input {...getInputProps()} />
//       <p>Glissez-déposez un fichier ici ou cliquez pour sélectionner un fichier</p>
//     </div>
//   );
// };

// export default FileUpload;

import { useDropzone } from "react-dropzone";
import { useState } from "react";
import { FiUploadCloud } from "react-icons/fi"; // Icône de cloud upload
import { useTranslation } from "react-i18next";

const FileUpload = ({ handleFileUpload }: { handleFileUpload: (file: File) => void }) => {
  const { t } = useTranslation();
  const [fileName, setFileName] = useState<string | null>(null);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: { 
      "application/vnd.ms-excel": [".xls", ".xlsx"],
      "text/csv": [".csv"],
      "application/vnd.oasis.opendocument.spreadsheet": [".ods"]
     },
    onDrop: (acceptedFiles) => {
      const file = acceptedFiles[0];
      if (file) {
        setFileName(file.name);
        handleFileUpload(file);
      }
    },
  });

  return (
    <div className="dropzone-container">
      <div {...getRootProps()} className={`dropzone ${isDragActive ? "active" : ""}`}>
        <input {...getInputProps()} />
        <FiUploadCloud size={50} className="upload-icon" />
        {fileName ? (
          <p className="file-name">📄 {fileName}</p>
        ) : (
          <p className="dropzone-text">
            {t('table.upload_box1')}<span className="browse-text">{t('table.upload_box2')}</span>
          </p>
        )}
      </div>
    </div>
  );
};

export default FileUpload;